import React from 'react';
import { Button } from 'antd';
import { GiftOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { TourTrashType } from '../../../../types/tourtrash';

interface WinnerColumnProps {
  record: TourTrashType;
}

export default React.memo((props: WinnerColumnProps) => {
  const { record } = props;
  return (
    <StyledContainer>
      <Button type="primary" shape="circle" icon={<GiftOutlined />} />
      {record.winner && <span>{record.winner.fullName}</span>}
      {!record.winner && <span className="tbd">TBD</span>}
    </StyledContainer>
  );
});

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  button {
    background: black;
    border-color: black;
    margin-right: 0.5rem;
  }
  span {
    font-weight: 600;
  }
`;
